import {
  REFERRALOUTCOME_TABLE,
  GET_REFERRALOUTCOME_LIST_PENDING,
  GET_REFERRALOUTCOME_LIST_FULFILLED,
  GET_REFERRALOUTCOME_LIST_REJECTED
} from '../../actions/action-constants'
const initialState = {
  title: 'Referral Outcomes',
  tablename: REFERRALOUTCOME_TABLE,
  referraloutcomes: [],
  loadingList: false,
  errors: []
}
const reducerReferralOutcomes = (state = initialState, action) => {
  var dataUndefinedTestReturn
  switch (action.type) {
    case GET_REFERRALOUTCOME_LIST_PENDING:
      state = {
        ...state,
        loadingList: true
      }
      break
    case GET_REFERRALOUTCOME_LIST_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        addSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        referraloutcomes: dataUndefinedTestReturn
      }
      break
    case GET_REFERRALOUTCOME_LIST_REJECTED:
      state = {
        ...state,
        errors: [action.payload.response]
      }
      break
    default:
      return state
  }
  return state
}
export default reducerReferralOutcomes
